import { Row, Col, Button, Card as AntCard, Avatar } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import {
   PageWrapper,
   HeroSection,
   HeroTitle,
   HeroDesc,
   Section,
   Container,
   SectionTitle,
   StyledCard,
   CardImage,
   TestimonialSection,
   TestimonialWrap,
   TestimonialText,
   TestimonialCard,
   TestimonialUser,
   SliderControl,
   ContactButtonBlack,
   BgDoiXeSection,
   HeroLayout,
   HeroLeft,
   HeroRight
} from './UserHomePage.styles'

import new_bg from 'src/assets/images/new_bg.svg'
import ic_link_black from 'src/assets/images/ic_link_black.svg'

import service_1 from 'src/assets/images/service_1.jpg'
import service_2 from 'src/assets/images/service_2.png'
import service_3 from 'src/assets/images/service_3.png'

import fleet_1 from 'src/assets/images/vf6.png'
import fleet_2 from 'src/assets/images/vf8.png'
import fleet_3 from 'src/assets/images/vf9.jpg'

import testimonial_avatar1 from 'src/assets/images/avatar_nv_3.jpg'
import testimonial_avatar2 from 'src/assets/images/avatar_nv_1.jpg'
import testimonial_avatar3 from 'src/assets/images/avatar_nv_2.jpg'
import Header from './Header'
import { Footer } from './Footer'
import BookingFlow from './BookingFlow'
import PromotionBanner from './PromotionBanner'
import { FloatingActions } from './FloatingActions'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { CONTACT_CONFIG } from 'src/helpers/constants'
import { usePageSeo } from 'src/helpers/usePageSeo'
import {
   breadcrumbSchema,
   organizationSchema,
   transportationServiceSchema,
   websiteSchema
} from 'src/helpers/seoStructuredData'
import { newsArticles } from '../news/newsData'
import { trackContactConversion } from 'src/helpers/googleAdsConversion'

const UserHomePage = observer(() => {
   usePageSeo({
      title: 'Xe ghép Thanh Hóa Hà Nội cao cấp, đặt xe nhanh trong ngày',
      description: `Đặt xe ghép Thanh Hóa Hà Nội, bao xe riêng và gửi hàng trong ngày. Xe đời mới, sạch sẽ, đón trả linh hoạt, hotline ${CONTACT_CONFIG.hotline}.`,
      keywords: [
         'xe ghép Thanh Hóa Hà Nội',
         'xe ghép Hà Nội Thanh Hóa',
         'đặt xe Thanh Hóa Hà Nội',
         'bao xe Thanh Hóa Hà Nội',
         'gửi hàng Thanh Hóa Hà Nội'
      ],
      structuredData: [organizationSchema, websiteSchema, transportationServiceSchema, breadcrumbSchema([{ name: 'Trang chủ', path: '/' }])]
   })

   const services = [
      {
         id: 0,
         title: 'Xe ghép ghế lẻ',
         description: 'Đón trả khách tận nơi, tiết kiệm chi phí di chuyển nhất.',
         img: service_1
      },
      {
         id: 1,
         title: 'Bao xe riêng biệt',
         description: 'Thuê trọn gói xe 5-7 chỗ, chủ động thời gian hoàn toàn',
         img: service_2
      },
      {
         id: 2,
         title: 'Gửi hàng nhanh chóng',
         description: 'Giao nhận bưu phẩm, thư tín thần tốc trong ngày',
         img: service_3
      }
   ]
   const list_car = [
      { id: 0, title: 'Vinfast VF6', description: 'Xe 5 chỗ kiểu dáng trẻ trung, vận hành siêu êm ái', img: fleet_1 },
      {
         id: 1,
         title: 'Vinfast VF8',
         description: 'Xe 5 chỗ sang trọng, bộ lọc không khí Combi 1.0, công nghệ Ion hóa loại bỏ nỗi lo say xe',
         img: fleet_2
      },
      { id: 2, title: 'Vinfast VF9', description: 'Xe 7 chỗ cao cấp, rộng rãi tiện nghi như xe chủ tịch', img: fleet_3 }
   ]
   const testimonials = [
      {
         id: 1,
         name: 'Nguyễn Văn Tuấn',
         role: 'Khách hàng',
         content:
            'Dịch vụ rất tốt, xe sạch sẽ, tài xế lịch sự. Mình có cài App Xe Ghép Thanh Hoá Hà Nội, khá tiện lợi nên mình sẽ tiếp tục sử dụng',
         avatar: testimonial_avatar1
      },
      {
         id: 2,
         name: 'Trần Thu Ngọc Ánh',
         role: 'Doanh nhân',
         content:
            'Xe mới, đi rất êm, đặt xe nhanh gọn. Trải nghiệm vượt mong đợi. Khi cần công tác tỉnh tôi luôn nghĩ tới LinhLinh36 đầu tiên!',
         avatar: testimonial_avatar2
      },
      {
         id: 3,
         name: 'Tường Vân',
         role: 'Nhân viên văn phòng',
         content:
            'Giá hợp lý, đón đúng giờ, tài xế rất thân thiện. Mình say xe nặng mà xe không mùi lại còn rất dễ chịu. Nói chung là 10 điểm.',
         avatar: testimonial_avatar3
      }
   ]
   const list_news = newsArticles.slice(0, 3)
   const ticketPrices = [
      {
         id: 1,
         route: 'Ba Đình - Thành Phố Thanh Hóa',
         price: '400k',
         car: 'Xe 5–7 chỗ đời mới',
         note: 'Xe ghép theo tuyến cố định, đón trả linh hoạt'
      },
      {
         id: 2,
         route: 'Ba Đình - Sầm Sơn',
         price: '400k',
         car: 'Nội thất rộng rãi, ghế ngồi êm',
         note: 'Phù hợp khách du lịch, đi lẻ'
      },
      {
         id: 3,
         route: 'Ba Đình - Bỉm Sơn',
         price: '350k',
         car: 'Xe vận hành êm ái, điều hòa mát sâu',
         note: 'Ghép khách cùng tuyến, chạy đúng giờ'
      },
      {
         id: 4,
         route: 'Ba Đình - Đông Sơn',
         price: '400k',
         car: 'Khoang xe thoáng, không mùi',
         note: 'Xe ghép chạy hàng ngày'
      },
      {
         id: 5,
         route: 'Ba Đình - Hà Trung',
         price: '400k',
         car: 'Xe mới, bảo dưỡng định kỳ',
         note: 'Thích hợp đi công tác, thăm thân'
      },
      {
         id: 6,
         route: 'Ba Đình - Hậu Lộc',
         price: '400k',
         car: 'Ghế ngồi thoải mái, không say xe',
         note: 'Đón trả trong khu vực trung tâm'
      },
      {
         id: 7,
         route: 'Ba Đình - Hoằng Hóa',
         price: '400k',
         car: 'Xe chạy ổn định, ít dừng đỗ',
         note: 'Ghép theo khung giờ cố định'
      },
      {
         id: 8,
         route: 'Ba Đình - Nga Sơn',
         price: '350k',
         car: 'Không gian yên tĩnh, dễ nghỉ ngơi',
         note: 'Lịch chạy đều, đúng tuyến'
      },
      {
         id: 9,
         route: 'Ba Đình - Ngọc Lặc',
         price: '450k',
         car: 'Xe chất lượng cao cho tuyến xa',
         note: 'Ưu tiên thoải mái cho hành trình dài'
      }
   ]
   const location = useLocation()
   const [index, setIndex] = useState(0)
   const current = testimonials[index]
   const next = () => setIndex((index + 1) % testimonials.length)
   const prev = () => setIndex((index - 1 + testimonials.length) % testimonials.length)
   useEffect(() => {
      if (!location.hash) return

      const id = location.hash.replace('#', '')
      const element = document.getElementById(id)

      if (element) {
         // delay nhẹ để đảm bảo DOM render xong
         setTimeout(() => {
            element.scrollIntoView({
               behavior: 'smooth',
               block: 'start'
            })
         }, 100)
      }
   }, [location.hash])
   return (
      <>
         <PageWrapper id="top">
            <Header />

            {/* HERO */}
            <HeroSection bg={new_bg}>
               <Container>
                  <HeroLayout>
                     <HeroLeft>
                        <HeroDesc>Bạn muốn đi đâu?</HeroDesc>
                        <HeroTitle>
                           Xe ghép cao cấp
                           <br />
                           Sạch sẽ · Êm ái · Sang trọng
                        </HeroTitle>
                     </HeroLeft>

                     <HeroRight>
                        <BookingFlow />
                     </HeroRight>
                  </HeroLayout>
               </Container>
            </HeroSection>

            <PromotionBanner />

            {/* Các section khác giữ nguyên */}
            <BgDoiXeSection id="services">
               <Container>
                  <SectionTitle>Dịch vụ của chúng tôi</SectionTitle>
                  <Row gutter={[24, 24]}>
                     {/* Thêm gutter dọc để khi xuống dòng không bị dính */}
                     {services.map((item, idx) => (
                        <Col xs={24} md={8} key={idx}>
                           <StyledCard cover={<CardImage src={item.img} alt={item.title} />} hoverable>
                              <AntCard.Meta title={item.title} description={item.description} />
                           </StyledCard>
                        </Col>
                     ))}
                  </Row>
               </Container>
            </BgDoiXeSection>

            {/* ================= FLEET ================= */}
            <BgDoiXeSection id="fleet">
               <Container>
                  <SectionTitle>Đội xe (Đời mới, từ 2025-2026)</SectionTitle>
                  <Row gutter={[24, 24]}>
                     {list_car.map((item, idx) => (
                        <Col xs={24} md={8} key={idx}>
                           <StyledCard cover={<CardImage src={item.img} alt={item.title} />} hoverable>
                              <AntCard.Meta title={item.title} description={item.description} />
                           </StyledCard>
                        </Col>
                     ))}
                  </Row>
               </Container>
            </BgDoiXeSection>

            {/* ================= TESTIMONIAL ================= */}
            <TestimonialSection id="testimonial">
               <Container>
                  <TestimonialWrap>
                     {/* LEFT */}
                     <TestimonialText>
                        <h2>Khách hàng nói gì về chúng tôi?</h2>
                        <p>Đây là những phản hồi chân thực từ khách hàng đã trải nghiệm dịch vụ của chúng tôi.</p>

                        <ContactButtonBlack
                           href={`tel:${CONTACT_CONFIG.hotline}`}
                           onClick={(event) => trackContactConversion(`tel:${CONTACT_CONFIG.hotline}`, event)}
                        >
                           Liên hệ
                           <img src={ic_link_black} alt="Gọi hotline xe ghép Thanh Hóa Hà Nội" />
                        </ContactButtonBlack>
                     </TestimonialText>

                     {/* RIGHT */}
                     <TestimonialCard>
                        <TestimonialUser>
                           <Avatar size={56} src={current.avatar} />
                           <div>
                              <div style={{ fontSize: 16, fontWeight: 600, color: '#000' }}>{current.name}</div>
                              <div style={{ fontSize: 12, fontWeight: 400, color: '#00000090' }}>{current.role}</div>
                           </div>
                        </TestimonialUser>

                        <p style={{ fontSize: 18, fontWeight: '500', lineHeight: 1.6, color: '#000' }}>
                           “{current.content}”
                        </p>

                        <SliderControl>
                           <Button onClick={prev}>
                              <LeftOutlined />
                           </Button>
                           <span>
                              {index + 1} / {testimonials.length}
                           </span>
                           <Button onClick={next}>
                              <RightOutlined />
                           </Button>
                        </SliderControl>
                     </TestimonialCard>
                  </TestimonialWrap>
               </Container>
            </TestimonialSection>

            {/* ================= NEWS ================= */}
            <Section style={{ background: '#f9f9f9' }} id="news">
               <Container>
                  <SectionTitle>Kinh nghiệm đi xe Thanh Hóa - Hà Nội</SectionTitle>
                  <Row gutter={24}>
                     {list_news.map((item, idx) => (
                        <Col xs={24} md={8} key={idx}>
                           <Link to={`/news/${item.slug}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                              <StyledCard cover={<CardImage src={item.image} alt={item.title} />} hoverable>
                                 <AntCard.Meta title={item.title} description={item.description} />
                              </StyledCard>
                           </Link>
                        </Col>
                     ))}
                  </Row>
                  <div style={{ marginTop: 28, textAlign: 'center' }}>
                     <Link
                        to="/news"
                        style={{
                           display: 'inline-flex',
                           alignItems: 'center',
                           justifyContent: 'center',
                           minHeight: 42,
                           padding: '0 22px',
                           border: '1px solid #111',
                           color: '#111',
                           fontWeight: 700
                        }}
                     >
                        Xem thêm
                     </Link>
                  </div>
               </Container>
            </Section>
            <Footer />
         </PageWrapper>
         <FloatingActions />
      </>
   )
})

export default UserHomePage
